<template>
    <div>
        <div>
            <div>
                <div style="display: flex;justify-content: flex-start">
                    <el-select v-model="searchValue.productCategoryId" clearable placeholder="产品分类">
                        <el-option
                                v-for="item in productCategorys"
                                :key="item.productCategoryId"
                                :label="item.productCategoryName"
                                :value="item.productCategoryId">
                        </el-option>
                    </el-select>
                    <el-select v-model="searchValue.productStatus" clearable placeholder="上架状态"
                               style="width: 100px;margin-left: 10px">
                        <el-option
                                v-for="item in productStatuss"
                                :key="item.status"
                                :label="item.name"
                                :value="item.status">
                        </el-option>
                    </el-select>
                    <el-input placeholder="产品编号" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProducts"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productId"
                              @keydown.enter.native="initProducts"></el-input>
                    <el-input placeholder="产品代码" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProducts"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productCode"
                              @keydown.enter.native="initProducts"></el-input>
                    <el-input placeholder="产品名称" prefix-icon="el-icon-search"
                              clearable
                              @clear="initProducts"
                              style="width: 150px;margin-left: 10px" v-model="searchValue.productName"
                              @keydown.enter.native="initProducts"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initProducts"
                               style="margin-left: 10px">
                        搜索
                    </el-button>
                </div>
                <div style="display: flex;justify-content: flex-start; margin-top: 10px">
                    <el-button type="primary" icon="el-icon-plus" @click="showAddProductView">
                        新增产品
                    </el-button>
                    <el-button type="success" icon="el-icon-upload2" :disabled="selectLoadValue" @click="loadBatch('1')">
                        批量上架
                    </el-button>
                    <el-button type="info" icon="el-icon-download" :disabled="selectUnloadValue" @click="loadBatch('0')">
                        批量下架
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    ref="productTable"
                    :data="products"
                    stripe
                    border
                    width="100%"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    @selection-change="selectLoad"
                    style="width: 100%">
                <el-table-column
                        type="selection"
                        min-width="3%">
                </el-table-column>
                <el-table-column
                        prop="productId"
                        align="center"
                        label="产品编号"
                        min-width="7%">
                </el-table-column>
                <el-table-column
                        prop="productCode"
                        label="产品代码"
                        align="center"
                        min-width="10%">
                </el-table-column>
                <el-table-column
                        prop="productCategoryName"
                        label="产品类别"
                        align="center"
                        min-width="8%">
                </el-table-column>
                <el-table-column
                        prop="productName"
                        label="产品概况"
                        align="center"
                        min-width="20%">
                </el-table-column>
                <el-table-column
                        prop="productPrice"
                        label="产品价格"
                        min-width="10%"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="productUnit"
                        label="产品单位"
                        min-width="8%"
                        align="center">
                </el-table-column>
                <el-table-column
                        prop="productStatus"
                        min-width="7%"
                        align="center"
                        label="上架状态">
                    <template slot-scope="scope">
                        <div>
                            <i class="el-icon-s-goods" :style="{'color': (scope.row.productStatus=='1'? '#67c23A':'#C8C9CC')}" ></i>
                            {{scope.row.idCard}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="productCreatetime"
                        min-width="12%"
                        align="center"
                        :formatter="formatDate"
                        label="添加时间">
                </el-table-column>
                <el-table-column
                        min-width="15%"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showUpdateProductView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteProduct(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
            <div style="padding: 25px">
                <div class="templateBottom">
                    <p style="height: 8px">说明:</p>
                    <p style="height: 5px">1.</p>
                    <p style="height: 5px">2.</p>
                    <p style="height: 5px">3.</p>
                </div>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogAddVisible"
                width="80%">
            <div>
                <el-form :model="product" :rules="rules" ref="productAddForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="产品代码:" prop="productCode">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="product.productCode"
                                      placeholder="请输入产品代码"></el-input>
                        </el-form-item>
                        <el-form-item label="产品名称:" prop="productName" style="padding-left: 50px">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="product.productName"
                                      placeholder="请输入产品名称"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="产品价格:" prop="productPrice">
                            <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="product.productPrice"
                                      placeholder="请输入产品价格"></el-input>
                        </el-form-item>
                        <el-form-item label="产品单位:" prop="productUnit" style="padding-left: 50px">
                            <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="product.productUnit"
                                      placeholder="请输入产品单位"></el-input>
                        </el-form-item>
                        <el-form-item label="产品分类:" prop="productCategoryId" style="padding-left: 50px;">
                            <el-select v-model="product.productCategoryId" clearable placeholder="产品分类">
                                <el-option
                                        v-for="item in productCategorys"
                                        :key="item.productCategoryId"
                                        :label="item.productCategoryName"
                                        :value="item.productCategoryId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProduct(product)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :title="title"
                :visible.sync="dialogUpdateVisible"
                width="80%">
            <div>
                <el-form :model="product" :rules="rules" ref="productUpdateForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="产品代码:" prop="productCode">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="product.productCode"
                                      placeholder="请输入产品代码"></el-input>
                        </el-form-item>
                        <el-form-item label="产品名称:" prop="productName" style="padding-left: 50px">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="product.productName"
                                      placeholder="请输入产品名称"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="产品价格:" prop="productPrice">
                            <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="product.productPrice"
                                      placeholder="请输入产品价格"></el-input>
                        </el-form-item>
                        <el-form-item label="产品单位:" prop="productUnit" style="padding-left: 50px">
                            <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="product.productUnit"
                                      placeholder="请输入产品单位"></el-input>
                        </el-form-item>
                        <el-form-item label="产品分类:" prop="productCategoryId" style="padding-left: 50px;">
                            <el-select v-model="product.productCategoryId" clearable placeholder="产品分类">
                                <el-option
                                        v-for="item in productCategorys"
                                        :key="item.productCategoryId"
                                        :label="item.productCategoryName"
                                        :value="item.productCategoryId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogUpdateVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateProduct(product)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    const axios = require('axios');
    export default {
        name: "Product",
        inject: ['reload'],
        data() {
            return {
                searchValue: {
                    productCategoryId: null,
                    productId: null,
                    productCode: '',
                    productName: '',
                    productStatus: ''
                },
                title: '',
                productStatuss: [
                    {name: "上架", status: "1"},
                    {name: "下架", status: "0"}
                ],
                productCategorys: [],
                products: [],
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                action: '',
                dialogAddVisible: false,
                dialogUpdateVisible: false,
                selectLoadValue: true,
                selectUnloadValue: true,
                product: {
                    productCategoryId: null,
                    productId: null,
                    productCode: '',
                    productName: '',
                    productPrice: '',
                    productUnit: '',
                    productStatus: ''
                },
                rules: {
                    productName: [{required: true, message: '请输入产品名称', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.getProductCategorys();
            this.initProducts();
        },
        watch:{
            total(){
                if(this.total==(this.page-1)*this.size && this.total!=0){
                    this.page-=1;
                    this.initTemplates();//获取列表数据
                }
            }
        },
        methods: {
            selectLoad() {
                var rows = this.$refs.productTable.selection;
                var tempLoad = true;
                var tempUnload = true;
                if (rows) {
                    rows.forEach(row => {
                        if(row.productStatus == '0'){
                            tempLoad = false;
                        }
                        if(row.productStatus == '1'){
                            tempUnload = false;
                        }
                    });
                }
                this.selectLoadValue = tempLoad;
                this.selectUnloadValue = tempUnload;
            },
            loadBatch(productStatus) {
                var rows = this.$refs.productTable.selection;
                var loadRows = new Array();
                var productIdList = new Array();
                if (rows) {
                    rows.forEach(row => {
                        if(productStatus == '1'){
                            if(row.productStatus == '0'){
                                loadRows.push(row);
                                productIdList.push(row.productId);
                            }
                        }else if(productStatus == '0'){
                            if(row.productStatus == '1'){
                                loadRows.push(row);
                                productIdList.push(row.productId);
                            }
                        }
                    });
                }
                if(loadRows){
                    var _this = this;
                    var productStr = "";
                    loadRows.forEach(row => {
                        productStr += row.productName + "、";
                    });
                    productStr = productStr.substring(0, productStr.length - 1);
                    var confirmStr = '';
                    if('1' == productStatus){
                        confirmStr = '是否确定上架 <p class="red">' + productStr + '</p>';
                    }else if('0' == productStatus){
                        confirmStr = '是否确定下架 <p class="red">' + productStr + '</p>';
                    }
                    this.$confirm(confirmStr, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        type: 'warning'
                    }).then(() => {
                        var params = {
                            productIdList: [],
                            productStatus: ''
                        };
                        params.productIdList = productIdList;
                        params.productStatus = productStatus;
                        _this.postRequest("/product/product/productLoad", params).then(resp => {
                            if (resp) {
                                _this.initProducts();
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消上架'
                        });
                    });
                }else {
                    this.$message({
                        type: 'info',
                        message: '请选择需要上架的产品。'
                    });
                }
            },
            formatDate(row, column) {
                // 获取单元格数据
                let productCreatetime = row.productCreatetime;
                if(productCreatetime == null) {
                    return '';
                }
                const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                let date = new Date(productCreatetime.replace(pattern, '$1-$2-$3 $4:$5:$6'));
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                return Y+M+D+h+m+s;
            },
            getProductCategorys() {
                this.loading = true;
                this.getRequest('/product/category/list').then(resp => {
                    if (resp) {
                        this.productCategorys = resp.data;
                    }
                });
            },
            showAddProductView() {
                this.title = '添加产品信息';
                this.emptyProduct();
                this.dialogAddVisible = true;
            },
            showUpdateProductView(data) {
                this.title = '编辑产品信息';
                this.emptyProduct();
                this.product = data;
                this.dialogUpdateVisible = true;
            },
            addProduct(product) {
                if(product){
                    this.$refs['productAddForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/product/product/add", product).then(resp => {
                                if (resp) {
                                    this.dialogAddVisible = false;
                                    this.initProducts();
                                }
                            })
                        }
                    });
                }
            },
            updateProduct(product) {
                if(product){
                    this.$refs['productUpdateForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/product/product/update", product).then(resp => {
                                if (resp) {
                                    this.dialogUpdateVisible = false;
                                    this.initProducts();
                                }
                            })
                        }
                    });
                }
            },
            deleteProduct(data) {
                this.$confirm('此操作将永久删除【' + data.productName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postRequest("/product/product/delete", data).then(resp => {
                        if (resp) {
                            this.initProducts();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            emptyProduct() {
                this.product = {
                    productCategoryId: null,
                    productId: null,
                    productCode: '',
                    productName: '',
                    productStatus: ''
                }
            },
            initProducts() {
                this.loading = true;
                let url = '/product/product/listByPage?page=' + this.page + '&size=' + this.size;
                if (this.searchValue.productCategoryId) {
                    url += '&productCategoryId=' + this.searchValue.productCategoryId;
                }
                if (this.searchValue.productId) {
                    url += '&productId=' + this.searchValue.productId;
                }
                if (this.searchValue.productCode) {
                    url += '&productCode=' + this.searchValue.productCode;
                }
                if (this.searchValue.productName) {
                    url += '&productName=' + this.searchValue.productName;
                }
                if (this.searchValue.productStatus) {
                    url += '&productStatus=' + this.searchValue.productStatus;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.products = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initProducts();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initProducts();
            }
        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .templateBottom {
        padding: 10px;
        background-color: #FFFFE0;
        box-sizing: border-box;
    }

    .templateType{
        margin-top: 8px;
    }

    .templateUpload{
        display: flex;
        display: -webkit-flex;
        align-items:center;
        justify-content:center
    }

    .hide .el-upload--picture-card {
        display: none;
    }

</style>